export default __webpack_public_path__ + "static/media/qlik.4fc728b5.png";